import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import About from './About';
import Support from './Support';
import AllBlogs from './AllBlogs';
import AuthPage from './components/AuthPage'; // Make sure this is imported
import TrackMed2 from './TrackMed2'; // Import TrackMed2
import ProtectedRoute from './components/ProtectedRoute';
import BottomNav from './components/BottomNav';
// import NotificationBootstrap from './components/NotificationBootstrap';
import { AuthProvider } from './context/AuthContext'; // Import AuthProvider
// import Analytics from './components/Analytics'; // Import Analytics
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<AuthPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/support" element={<Support />} />
          <Route path="/blog" element={<AllBlogs />} />
          
          {/* Protected Routes */}
          <Route 
            path="/trackmed2" 
            element={
              <ProtectedRoute>
                <TrackMed2 />
              </ProtectedRoute>
            } 
          />
          
          {/* Home Route */}
          <Route path="/" element={<Home />} />
        </Routes>
       
      </Router>
    </AuthProvider>
  );
}

export default App;